export default function InstructorTerms() {
  return (
    <div style={{ maxWidth: '800px', padding: '0 20px', margin: '150px auto' }}>
      <p>Instructor Terms of Service</p>

      <p>These Terms of Use (&quot;Terms&quot;) were last updated on January 11, 2020.</p>

      <p>​</p>

      <p>
        When you sign up to become an instructor on the AUMHUM platform, you agree to abide by these
        Instructor Terms (&quot;Terms&quot;). These Terms cover details about the aspects of the
        AUMHUM platform relevant to instructors and are incorporated by reference into our&nbsp;
        <a href="https://aumhum.com/terms/" rel="noreferrer" target="_blank">
          Terms of Use
        </a>
        , the general terms that govern your use of our Services. Any capitalized terms that
        aren&#39;t defined in these Terms are defined as specified in the Terms of Use.
      </p>

      <p>
        As an instructor, you are contracting directly with Aumhum Pte Ltd. (a Singapore
        corporation), regardless of whether another Aumhum affiliate facilitates payments to you.
      </p>

      <p>​</p>

      <p>1. Instructor Obligations</p>

      <p>
        As an instructor, you are responsible for all content that you post, including audio
        sessions, video sessions, lectures, quizzes, training exercises, practice tests,
        assignments, resources, answers, course landing page content, and announcements
        (&quot;Submitted Content&quot;).
      </p>

      <p>You represent and warrant that:</p>

      <ul>
        <li>
          <p>you will provide and maintain accurate account information;</p>
        </li>
        <li>
          <p>
            you own or have the necessary licenses, rights, consents, permissions, and authority to
            authorize AUMHUM to use your Submitted Content as specified in these Terms and the Terms
            of Use;
          </p>
        </li>
        <li>
          <p>
            your Submitted Content will not infringe or misappropriate any third party&#39;s
            intellectual property rights;
          </p>
        </li>
        <li>
          <p>
            you have the required qualifications, credentials, and expertise (including education,
            training, knowledge, and skill sets) to teach and offer the services that you offer
            through your Submitted Content and use of the Services; and
          </p>
        </li>
        <li>
          <p>
            you will respond promptly to Students and ensure a quality of service that corresponds
            with the standards of your industry and instruction services in general.
          </p>
        </li>
        <li>
          <p>You warrant that you will not:</p>
        </li>
        <li>
          <p>
            post or provide any inappropriate, offensive, racist, hateful, sexist, pornographic,
            false, misleading, incorrect, infringing, defamatory or libelous content or information;
          </p>
        </li>
        <li>
          <p>
            post or transmit any unsolicited or unauthorized advertising, promotional materials,
            junk mail, spam, or any other form of solicitation (commercial or otherwise) through the
            Services or to any user;
          </p>
        </li>
        <li>
          <p>
            use the Services for business other than providing tutoring, teaching, monitoring
            progress, providing guidance and instructional services to students;
          </p>
        </li>
        <li>
          <p>
            engage in any activity that would require us to obtain licenses from or pay royalties to
            any third party, including the need to pay royalties for the public performance of a
            musical work or sound recording;
          </p>
        </li>
        <li>
          <p>
            frame or embed the Services (such as to embed a free version of a meditation ) or
            otherwise circumvent the Services;
          </p>
        </li>
        <li>
          <p>
            impersonate another person or gain unauthorized access to another person&#39;s account;
          </p>
        </li>
        <li>
          <p>
            interfere with or otherwise prevent other Instructors from providing their services or
            courses; or
          </p>
        </li>
        <li>
          <p>abuse Aumhum resources, including support services.</p>
        </li>
      </ul>

      <p>​</p>

      <p>2. License to AUMHUM</p>

      <p>
        You grant Aumhum the rights detailed in the Terms of Use to offer, market, and otherwise
        exploit your Submitted Content, and to sublicense it to students for these purposes directly
        or through third parties. This includes the right to add captions or otherwise modify
        content to ensure accessibility.
      </p>

      <p>
        Unless otherwise agreed (including within our Promotions Policy), you have the right to
        remove all or any portion of your Submitted Content from the Services at any time, provided
      </p>

      <p>
        that once you initiate the process to remove the Submitted Content, the removal shall take
        effect only after the expiry of 60 days. However:
      </p>

      <p>
        (i) rights given to students before the Submitted Content&#39;s removal will continue in
        accordance with the terms of those licenses (including any grants of lifetime access) and;
      </p>

      <p>
        (ii) AUMHUM&#39;s right to use such Submitted Content for marketing purposes shall survive
        termination.
      </p>

      <p>
        We may record all or any part of your Submitted Content for quality control and for
        delivering, marketing, promoting, demonstrating, or operating the Services. You grant AUMHUM
        permission to use your name, likeness, voice, calendar of activities, profile information,
        any other information provided by you and image in connection with the offering, delivering,
        marketing, promoting, demonstrating, and selling the Services, your Submitted Content, or
        AUMHUM&#39;s content, and you waive any rights of privacy, publicity, or other rights of a
        similar nature, to the extent permissible under applicable law.
      </p>

      <p>&nbsp;</p>

      <p>3. Trust &amp; Safety</p>

      <p>&nbsp;</p>

      <p>3.1 Trust &amp; Safety Policies</p>

      <p>
        You agree to abide by AUMHUM&#39;s Trust &amp; Safety policies, Restricted Topics policy,
        and other meditation content quality standards or policies prescribed by AUMHUM from time to
        time. You should check these policies periodically to ensure that you comply with any
        updates to them. You understand that your use of the Services is subject to AUMHUM&#39;s
        approval, which we may grant or deny at our sole discretion.
      </p>

      <p>
        We reserve the right to remove meditation content, suspend payouts, and/or ban instructors
        for any reason at any time, without prior notice, including in cases where:
      </p>

      <ul>
        <li>
          <p>
            an instructor or meditation content does not comply with our policies or legal terms
            (including the Terms of Use);
          </p>
        </li>
        <li>
          <p>
            a meditation content&nbsp; falls below our quality standards or has a negative impact on
            the student experience;
          </p>
        </li>
        <li>
          <p>
            an instructor engages in behavior that might reflect unfavorably on AUMHUM&nbsp; or
            bring AUMHUM into public disrepute, contempt, scandal, or ridicule;
          </p>
        </li>
        <li>
          <p>
            an instructor engages the services of a marketer or other business partner who violates
            AUMHUM&#39;s policies; or
          </p>
        </li>
        <li>
          <p>as determined by AUMHUM in its sole discretion.</p>
        </li>
      </ul>

      <p>&nbsp;</p>

      <p>3.2 Co-Instructors and Teaching Assistants</p>

      <p>
        The AUMHUM platform allows you to add other users as co-instructors or teaching assistants
        for courses that you manage. By adding a co-instructor or teaching assistant, you understand
        that you are authorizing them to take certain actions that affect your AUMHUM account and
        courses. AUMHUM is not able to advise on any questions or mediate any disputes between you
        and such users. If your co-instructors have an assigned revenue share, their share will be
        paid out of your earned revenue share based on the ratios you have specified in your Course
        Management settings as of the date of the purchase.
      </p>

      <p>​</p>

      <p>3.3 Relationship to Other Users</p>

      <p>
        Instructors don&#39;t have a direct contractual relationship with students, so the only
        information you&#39;ll receive about students is what is provided to you through the
        Services. You agree that you will not use the data you receive for any purpose other than
        providing your services to those students on the AUMHUM platform and that you won&#39;t
        solicit additional personal data or store students&#39; personal data outside the AUMHUM
        platform. You will indemnify AUMHUM against any claims arising from your use of
        students&#39; personal data.
      </p>

      <p>​</p>

      <p>3.4 Anti-Piracy Efforts</p>

      <p>
        We may at our sole discretion partner with anti-piracy vendors to help protect your
        meditation content from unauthorized use. To enable this protection, you hereby appoint
        AUMHUM and our anti-piracy vendors as your agents for the purpose of enforcing copyrights
        for each of your courses, through notice and takedown processes (under applicable copyright
        laws) and for other efforts to enforce those rights. You grant AUMHUM and our anti-piracy
        vendors the primary authority to file notices on your behalf to enforce your copyright
        interests.
      </p>

      <p>
        You agree that AUMHUM and our anti-piracy vendors will retain the above rights unless you
        revoke them by sending an email to&nbsp;
        <a href="mailto:piracy@aumhum.com">piracy@aumhum.com</a>&nbsp;with the subject line:
        &quot;Revoke Anti-Piracy Protection Rights&quot; from the email address associated with your
        account. Any revocation of rights will be effective 48 hours after we receive it.
      </p>

      <p>​</p>

      <p>4. Trademarks</p>

      <p>
        While you are a published instructor and subject to the requirements below, you may use our
        trademarks where we authorize you to do so.
      </p>

      <p>You must:</p>

      <ul>
        <li>
          <p>
            only use the images of our trademarks that we make available to you, as detailed in any
            guidelines we may publish (such as our Instructor Badge Guide);
          </p>
        </li>
        <li>
          <p>
            only use our trademarks in connection with the promotion and sale of your AUMHUM courses
            or your participation on AUMHUM; and
          </p>
        </li>
        <li>
          <p>immediately comply if we request that you discontinue use.</p>
        </li>
      </ul>

      <p>You must not:</p>

      <ul>
        <li>
          <p>use our trademarks in a misleading or disparaging way;</p>
        </li>
        <li>
          <p>
            use our trademarks in a way that implies that we endorse, sponsor, or approve of your
            courses or services; or
          </p>
        </li>
        <li>
          <p>
            use our trademarks in a way that violates applicable law or in connection with an
            obscene, indecent, or unlawful topic or material.
          </p>
        </li>
      </ul>

      <p>&nbsp;</p>

      <p>5. Sanctions and Export Laws</p>

      <p>
        You warrant that you aren&#39;t restricted from using the Services under any sanctions or
        export laws (as an individual or as an officer, director, or controlling shareholder of any
        entity on whose behalf you use the Services). If you become subject to such a restriction
        while you are subject to these Instructor Terms, you will notify AUMHUM within 24 hours, and
        we will have the right to terminate any further obligations to you, effective immediately
        and with no further liability to you (but without prejudice to your outstanding obligations
        to AUMHUM). You will not use the Services to conduct or facilitate any transaction with any
        other individual or entity subject to such a restriction. You may not remove, export, or
        allow the export or re-export of the Services (or any product thereof, including technical
        data) in violation of any restrictions, laws, or regulations of any applicable country.
      </p>

      <p>&nbsp;</p>

      <p>6. Deleting Your Account</p>

      <p>
        Instructions on how to delete your instructor account are available here. We&#39;ll use
        commercially reasonable efforts to make any remaining scheduled payments that are owed to
        you before deleting your account. You understand that if students have previously enrolled
        in your courses, your name and that Submitted Content will remain accessible to those
        students after your account is deleted. If you need help or encounter difficulty deleting
        your account, you can contact us via our Support Center.
      </p>

      <p>​</p>

      <p>7. Miscellaneous Legal Terms</p>

      <p>​</p>

      <p>7.1 Updating These Terms</p>

      <p>
        From time to time, we may update these Terms to clarify our practices or to reflect new or
        different practices (such as when we add new features), and AUMHUM reserves the right in its
        sole discretion to modify and/or make changes to these Terms at any time. If we make any
        material change, we will notify you using prominent means such as by email notice sent to
        the email address specified in your account or by posting a notice through our Services.
        Modifications will become effective on the day they are posted unless stated otherwise.
      </p>

      <p>
        Your continued use of our Services after changes become effective shall mean that you accept
        those changes. Any revised Terms shall supersede all previous Terms.
      </p>

      <p>​</p>

      <p>7.2 Translations</p>

      <p>
        Any version of these Terms in a language other than English is provided for convenience and
        you understand and agree that the English language will control if there is any conflict.
      </p>

      <p>​</p>

      <p>7.3 Relationship Between Us</p>

      <p>
        You and we agree that no joint venture, partnership, employment, agency relationship exists
        between us.
      </p>

      <p>​</p>

      <p>7.4 Survival</p>

      <p>
        The following sections shall survive the expiration or termination of these Terms: Sections
        2 (License to AUMHUM), 3.3 (Relationship to Other Users), 5.2 (Receiving Payments), 5.3
        (Refunds), 8 (Deleting Your Account), and 9 (Miscellaneous Legal Terms).
      </p>

      <p>​</p>

      <p>8. How to Contact Us</p>

      <p>
        The best way to get in touch with us is to contact our&nbsp;
        <a href="mailto:namaste@aumhum.com" rel="noreferrer" target="_blank">
          Support Team
        </a>
        . We&#39;d love to hear your questions, concerns, and feedback about our Services.
      </p>

      <p>​</p>
    </div>
  )
}
